import { SelectorState } from './reducerFor'
import fetchSelectors from '../fetch/selectors'

const selectorSelectors = <T, S>(getAll: (state: S) => SelectorState<T>) => {
  return {
    ...fetchSelectors<T[], S>(getAll),
    selected: (state: S): T | undefined => getAll(state).selected,
    selectedResources: (state: S): T[] | undefined => getAll(state).selectedResources
  }
}

export default selectorSelectors
